module.exports = __webpack_public_path__ + "img/icp.b78b2ee0.svg";